import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d93ef9a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Changelog", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", { open: "" }, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.3 For the Senses - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-17")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 5e46 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 33-44"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Light and Sound."),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "A few minor bugfixes, and updated to Profectus 0.4.1")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.2 Bond Glue - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-09")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 1.4e25 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 24-32"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Intrabonds"),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, " Fixed a bug with the Cryo Challenge rewards not being dependent on the right challenge completions (this might slightly slow down your particles/s, but not substantially enough to be a problem) ")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.1.1 Big Loar - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-05")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 1e17 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 22-23"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Added a Lore node because why not :)")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.1 Particle Combinators - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-05-03")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 1e14 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 16-21"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Particle Combinators"),
    /*#__PURE__*/_createElementVNode("li", { class: "breaking" }, " Updated to Profectus v0.4, which caused saves to glitch out a bit. Here is a list of everything that may have reset for you: Flame Upgrades, Life Buyables, and the Earth Grid (but not its level) ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.0.2 Tooltip Heaven - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-24")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Updated to Profectus v0.3.3"),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Added tooltips to layer nodes (thanks to thepaperpilot)"),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, " Added modifier tooltips to reset buttons (note that it's not in the Aqua layer, it doesn't let you click the reset button when it is, so I had to remove it for the time being while I try to figure that out) "),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, " Fixed the way that the branched reset propagation works (I really borked that one up lol) ")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.0.1 Refined Edges - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-24")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, "Updated to Profectus v0.3.2"),
    /*#__PURE__*/_createElementVNode("li", { class: "fix" }, " Added glow color to certain layers (thanks to thepaperpilot) ")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v1.0 Our Planet - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-23")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 3e9 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 11-15"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Earth layer")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.3 Windseeker - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-14")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 40,500,000 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 7-11"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Air layer")
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.2 Several Advancements - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-11")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "balancing" }, "Balanced up to 43,000 Particles/s"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancements 2-6"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Cryo layer")
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("details", null, [
  /*#__PURE__*/_createElementVNode("summary", null, [
    /*#__PURE__*/_createTextVNode("v0.1 Basic Mechanics - "),
    /*#__PURE__*/_createElementVNode("time", null, "2022-04-08")
  ]),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Flame, Life, & Water layers"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Advancement 1"),
    /*#__PURE__*/_createElementVNode("li", { class: "feature" }, "Implemented Lightning layer")
  ])
], -1))

import Modal from "components/Modal.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const isOpen = ref(false);

expose({
    open() {
        isOpen.value = true;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})